import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  name: 'exchange_record',
  props: {
    value: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.params.consumerOpenId = val.consumerOpenId;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      requestType: 'POST',
      params: {
      },
      isCalculateHeight: false,
    };
  },
  created() {
    this.getConfigList('exchange_record');
  },

  methods: {
  },
};
